export default "__VITE_ASSET__BJJzjYg7__"